(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _osProps = _interopRequireDefault(_osProps);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nav', {
        staticClass: "nx-nav-bar",
        class: [_vm.positionType, {
          'nx-os-blur-material': _vm.blurMaterial
        }]
      }, [_c('div', {
        ref: "wrapper",
        staticClass: "nx-nav-bar-inner"
      }, [_c('div', {
        staticClass: "nx-nav-bar-wrap"
      }, [_c('div', {
        staticClass: "nx-nav-bar-list"
      }, _vm._l(_vm.items, function (item, index) {
        return _c('a', {
          key: item.name,
          ref: "items",
          refInFor: true,
          staticClass: "nx-nav-bar-item",
          class: [{
            'is-active': _vm.currentName === item.name,
            'is-disabled': !!item.disabled
          }, _vm.flexDirection],
          attrs: {
            "tabindex": "0"
          },
          on: {
            "click": function click($event) {
              return _vm.$_onClick(item, index);
            }
          }
        }, [_vm._t("default", [_vm._v(_vm._s(item.label))], {
          "item": item,
          "items": _vm.items,
          "index": index,
          "currentName": _vm.currentName
        })], 2);
      }), 0)])])]);
    },
    name: 'nx-nav-bar',
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      items: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      immediate: {
        type: Boolean,
        default: false
      },
      positionType: {
        type: String,
        default: 'bottom' // navBar 位置，bottom（默认）：居底，top：居顶，relative：默认布局

      },
      flexDirection: {
        type: String,
        default: 'flex-row' // icon 排列方式，flex-row（默认）：横向，flex-column：纵向

      }
    },
    mixins: [_osProps.default],
    data: function data() {
      return {
        currentName: '',
        wrapperW: 0,
        contentW: 0
      };
    },
    computed: {
      /* eslint-disable vue/return-in-computed-property */
      currentIndex: function currentIndex() {
        for (var i = 0, len = this.items.length; i < len; i++) {
          if (this.items[i].name === this.currentName) {
            return i;
          }
        }
      },

      /* eslint-disable vue/return-in-computed-property */
      currentTab: function currentTab() {
        if (this.currentIndex) {
          return this.items[this.currentIndex];
        }
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function handler(val) {
          if (val !== this.currentName) {
            this.currentName = val;
          }
        }
      },
      items: function items() {
        this.$nextTick(function () {// this.reflow()
        });
      },
      currentIndex: function currentIndex() {
        this.$nextTick(function () {// this.reflow()
        });
      }
    },
    created: function created() {
      if (this.currentName === '' && this.items.length) {
        this.currentName = this.items[0].name;
        this.$emit('change', this.items[0], 0, 0);
      }
    },
    mounted: function mounted() {
      var _this = this;

      // window.addEventListener('resize', this.reflow)
      // this.reflow()
      if (this.immediate) {
        this.$nextTick(function () {
          _this.$emit('change', _this.items[_this.currentIndex], _this.currentIndex);
        });
      }
    },
    beforeDestroy: function beforeDestroy() {// window.removeEventListener('resize', this.reflow)
    },
    methods: {
      $_onClick: function $_onClick(item, index) {
        if (item.disabled) {
          return;
        }

        this.$emit('change', item, index, this.currentIndex);
        this.currentName = item.name;
        this.$emit('input', item.name);
      } // MARK: public methods
      // reflow() {
      //   if (!this.$refs.items || this.$refs.items.length === 0) {
      //     return
      //   }
      //   this.wrapperW = this.$refs.wrapper.offsetWidth
      //   let contentWidth = 0
      //   for (let i = 0, len = this.items.length; i < len; i++) {
      //     contentWidth += this.$refs.items[i].offsetWidth
      //   }
      //   this.contentW = contentWidth
      // },

    }
  };
  _exports.default = _default2;
});